import {setLocale} from 'yup';

setLocale({
  mixed: {
    required: 'This field is required.',
    notType: 'This field is required.',
  },
});
